import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { PICFLOW_MAINTENANCE } from '../../maintenance';
import { RedirectService } from '../../services/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class TenantProfileMaintenanceGuard {
  private redirectService = inject(RedirectService);
  private maintenance = inject(PICFLOW_MAINTENANCE);
  private platformId = inject(PLATFORM_ID);

  async canActivate(): Promise<UrlTree | boolean> {
    if (isPlatformServer(this.platformId)) return true;
    if (await firstValueFrom(this.maintenance.getRealTimeMaintenanceMode())) return true;
    return this.redirectService.redirectTo(['']);
  }
}
